import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { PortalToBody } from '../../../system/util/PortalToBody';
import { useDatePickerClassNames } from '../hooks/useDatePickerClassNames';
import { useDatePicker } from './hooks/useDatePicker';
import { DatePickerRoot } from './style';
import { DatePickerInput, DatePickerInputIcon, DatePickerDropdown, DatePickerDropdownArrow } from '../style';
import { DATE_PICKER_CLASS_PREFIX } from '../constants';
import { DatePickerTimeSelector } from '../DatePickerTimeSelector';
import { DatePickerActionBar } from '../DatePickerActionBar';
import { DatePickerMonthYearSelector } from '../DatePickerMonthYearSelector';
import { DatePickerDaySelector } from '../DatePickerDaySelector';
import { DatePickerTopBar } from '../DatePickerTopBar';
import { useComponentTheme } from '../../../utils/hooks';
export var DatePicker = forwardRef(function DatePicker(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DATE_PICKER_CLASS_PREFIX);
  var classNameComponents = useDatePickerClassNames(DATE_PICKER_CLASS_PREFIX, className);

  var _useDatePicker = useDatePicker(props, ref),
      portalProps = _useDatePicker.portalProps,
      rootProps = _useDatePicker.rootProps,
      inputProps = _useDatePicker.inputProps,
      dropdownProps = _useDatePicker.dropdownProps,
      arrowProps = _useDatePicker.arrowProps,
      topBarProps = _useDatePicker.topBarProps,
      daySelectorProps = _useDatePicker.daySelectorProps,
      monthYearSelectorProps = _useDatePicker.monthYearSelectorProps,
      actionBarProps = _useDatePicker.actionBarProps,
      timeSelectorProps = _useDatePicker.timeSelectorProps,
      displayMonthYearSelector = _useDatePicker.displayMonthYearSelector,
      open = _useDatePicker.open,
      enableActionButtons = _useDatePicker.enableActionButtons,
      enableTimePicker = _useDatePicker.enableTimePicker;

  return React.createElement(DatePickerRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerInput, Object.assign({}, inputProps, {
    className: classNameComponents.Input,
    after: React.createElement(DatePickerInputIcon, {
      theme: theme
    })
  })), open && React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(DatePickerDropdown, Object.assign({}, dropdownProps, {
    theme: theme,
    className: classNameComponents.Dropdown
  }), React.createElement(DatePickerTopBar, Object.assign({}, topBarProps)), displayMonthYearSelector && React.createElement(DatePickerMonthYearSelector, Object.assign({}, monthYearSelectorProps)), !displayMonthYearSelector && React.createElement(DatePickerDaySelector, Object.assign({}, daySelectorProps)), enableTimePicker && React.createElement(DatePickerTimeSelector, Object.assign({}, timeSelectorProps)), enableActionButtons && React.createElement(DatePickerActionBar, Object.assign({}, actionBarProps)), React.createElement(DatePickerDropdownArrow, Object.assign({}, arrowProps, {
    theme: theme
  })))));
});
DatePicker.defaultProps = {};